import {
    isAfter,
    addDays,
    addMonths,
    isToday,
    isWithinInterval,
} from "date-fns";

export function getLastWeekLeads(leads) {
    const today = new Date();
    const lastWeek = addDays(today, -7);
    const lastWeekLeads = leads.filter((e) =>
        isAfter(new Date(e.fecha), lastWeek)
    );
    return lastWeekLeads;
}

export function getLastMonthLeads(leads) {
    const today = new Date();
    const lastMonth = addDays(today, -30);
    const lastMonthLeads = leads.filter((e) =>
        isAfter(new Date(e.fecha), lastMonth)
    );
    return lastMonthLeads;
}

export function getTodayLeads(leads) {
    const todayLeads = leads.filter((e) =>
        isToday(new Date(e.fecha + "T00:00:00"))
    );

    return todayLeads;
}

export function getCustomDateLeads(leads, dates) {
    const selectedLeads = leads.filter((e) => {
        return isWithinInterval(new Date(e.fecha), {
            start: new Date(dates.dateFrom),
            end: new Date(dates.dateTo),
        });
    });

    return selectedLeads;
}

export function getTodayCount(leads) {
    let count = 0;
    leads.forEach((e) => {
        if (isToday(new Date(e.fecha))) {
            count++;
        }
    });
    return count;
}

export function getWeekCount(leads) {
    const today = new Date();
    const lastWeek = addDays(today, -7);
    let count = 0;
    leads.forEach((e) => {
        if (isAfter(new Date(e.fecha), lastWeek)) {
            count++;
        }
    });
    return count;
}

export function getMonthCount(leads) {
    const today = new Date();
    const lastMonth = addMonths(today, -1);
    let count = 0;

    leads.forEach((e) => {
        if (isAfter(new Date(e.fecha), lastMonth)) {
            count++;
        }
    });
    return count;
}

export function search(query, leads) {
    if (query !== "") {
        const queryToLower = query.toLowerCase();
        const filters = leads.filter((lead) => {
            return (
                lead.nombre.toLowerCase().includes(queryToLower) ||
                lead.apellido.toLowerCase().includes(queryToLower) ||
                lead.email.toLowerCase().includes(queryToLower)
            );
        });
        return filters;
    } else {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/helpers/LeadsHelpers.js